'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _iconsPopupActions = require('../iconsPopupActions');

require('./IconPopupModeButton.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Actions
// Lib
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        changePopupMode: function changePopupMode(event) {
            event.preventDefault();
            dispatch((0, _iconsPopupActions.setIconPopupMode)({ mode: ownProps.mode.slug }));
        }
    };
};

// Styles


var IconPopupModeButton = function IconPopupModeButton(_ref) {
    var mode = _ref.mode,
        popupMode = _ref.popupMode,
        changePopupMode = _ref.changePopupMode;
    return _react2.default.createElement(
        'a',
        { href: '#',
            onClick: changePopupMode,
            className: (0, _classnames2.default)('IconPopupModeButton', { active: mode.slug === popupMode }) },
        _react2.default.createElement(
            'span',
            { className: 'title' },
            mode.title
        )
    );
};

IconPopupModeButton.propTypes = {
    mode: _propTypes2.default.object,
    popupMode: _propTypes2.default.string,
    changePopupMode: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(IconPopupModeButton);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/toolbar/selectionTools/iconTools/popup/modeMenu/IconPopupModeButton.js
// module id = 2237
// module chunks = 0